import React from 'react';
import { Box } from '@mui/material';

import { VideoInfoLine } from '../../VideoInfoLine';
import { Video } from '../../../types';
import styles from './style';

interface FooterProps {
  inTiktok: boolean;
  video: Video;
}

// Bottom left of the video: the creator, the description and the info cards.
const Footer = React.memo((props: FooterProps) => {
  const { inTiktok, video } = props;

  return (
    <Box sx={inTiktok ? styles.footerTiktok : styles.footer}>
      {video.user && (
        <Box component="span" sx={styles.username}>
          {video.user.username}
        </Box>
      )}
      {video.description && (
        <Box component="span" sx={styles.description}>
          {video.description}
        </Box>
      )}
      <VideoInfoLine video={video} hideGame />
    </Box>
  );
});

export default Footer;
